// Rounds a monetary value to 2 decimal places to strip floating-point noise
// (e.g. 1.5 * 79.9 = 119.85000000000001). Totals are NOT rounded to whole taka.
export const roundMoney = (value: number): number =>
  Math.round((value + Number.EPSILON) * 100) / 100;
